import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PwaInstallComponent } from './pwa-install/pwa-install.component';
import { UpdateNotificationComponent } from './update-notification/update-notification.component';
import { ThemeToggleComponent } from '../shared/theme-toggle/theme-toggle.component';

@NgModule({
  declarations: [
    PwaInstallComponent,
    UpdateNotificationComponent,
    ThemeToggleComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    PwaInstallComponent,
    UpdateNotificationComponent,
    ThemeToggleComponent
  ]
})
export class ComponentsModule { }
